import React, { PropsWithChildren } from 'react';
import DebugBoxSmall from './DebugBoxSmall';

/** Place within a production component (i.e., not another debug box). **/
const DebugNote = (props: PropsWithChildren<object>) =>
    <DebugBoxSmall withinDebugBox={ false }>
        <p style={ { marginBlockStart: '0px' } }>{props.children}</p>
    </DebugBoxSmall>;

export default DebugNote;
